var config = {
  mapResources: function mapResources(url) {
    return url;
  },
  sanitiseEndpoints: function sanitiseEndpoints(url) {
    return url;
  }
};
export function configure(resourceTimingConfig) {
  config = resourceTimingConfig;
}
export var getConfig = function getConfig() {
  return config;
};